import { AppBar, styled, Toolbar } from "@mui/material";

import { AppBreadcrumbs } from "components/breadcrumb/AppBreadcrumbs";
import { IntroductionButton } from "components/introduction/IntroductionButton";
import { JoyrideActivateButton } from "components/joyride/JoyrideActivateButton";

interface Props {}

export function Header(props: Props) {
  return (
    <StyledToolbar position="relative" color="inherit" elevation={0}>
      <Toolbar className="flex">
        <AppBreadcrumbs />
        <div className="how-to-buttons">
          <IntroductionButton />
          <JoyrideActivateButton />
        </div>
      </Toolbar>
    </StyledToolbar>
  );
}

const StyledToolbar = styled(AppBar)`
  .flex {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 0;
  }
`;
